import { DoubleListBlock, ListItem as ListItemBlock } from "graphql/generated-types";

const ListItem = ({ item }: { item: ListItemBlock }) => {
	return <li className={item.indentationLevel == 2 ? "ml-4" : ""}>– {item.text}</li>;
};

const ColumnListBlock = ({ block }: { block: DoubleListBlock }) => {
	return (
		<div className="container sm:grid sm:grid-cols-2 gap-x-12 md:grid-cols-3">
			{block.heading && <h3 className="col-span-2 text-lg lg:text-2xl md:col-span-3 mb-7">{block.heading}</h3>}
			<ul>
				{block.columnOne?.map((item, index) => (
					<ListItem key={index} item={item as ListItemBlock} />
				))}
			</ul>
			<ul>
				{block.columnTwo?.map((item, index) => (
					<ListItem key={index} item={item as ListItemBlock} />
				))}
			</ul>
		</div>
	);
};

export default ColumnListBlock;
